import require from '@/utils/request'
import { FetchIasListPramas, SaveCalcGroupParams } from '@/types/tenant/calcGroup'
import { qs } from '@/utils/tools'

/**
 * v5-运算组分页查询
 */
export const fetchIasList = (params: FetchIasListPramas) => require({
  url: `/blackcat/ias/page?${qs(params)}`,
  method: 'get'
})

/**
 * v5-ias运算组详情
 */
export const fetchIasDetail = (params: {id: string}) => require({
  url: `/blackcat/ias/detail?${qs(params)}`,
  method: 'get'
})

/**
 * v5-ias保存运算组
 */
export const saveIasGroup = (data: SaveCalcGroupParams) => require({
  url: '/blackcat/ias/save',
  method: 'post',
  data
})

/**
 * v5-根据类型获取运算组
 */
export const getIasGroup = (data: {storyLineType: string}) => require({
  url: `/blackcat/ias/type?storyLineType=${data.storyLineType}`,
  method: 'get'
})
